import template from './form.html';
import { FormActions } from 'core/services/form';
import configFile from 'config.json';
import { rest } from 'core/api';
import clientesI18N from 'i18n/clientes/es.json';
import commonI18N from 'i18n/common/es.json';
import { formatErrorMessage } from 'core/util';


export let ClienteFormComponent = {
  templateUrl: template,
  selector: 'clienteForm',
  bindings: {
    view: '<',
    translations: '='
  },
  controller: FormController,
  controllerAs: 'vm'
};

export const translationKeys = Object.keys(clientesI18N).concat(Object.keys(commonI18N));


FormController.$inject = ['$state', '$ngRedux', '$compile', 'ngNotify', 'Filter', 'BasicFactory', '$stateParams', '$timeout', '$scope'];

function FormController($state, $ngRedux, $compile, ngNotify, Filter, BasicFactory, $stateParams, $timeout, $scope) {
  this.uploadOptions = {
    imageOnly: true,
    target: configFile.serverURL + '/adjuntos',
    publicPath: configFile.publicURL
  };
  this.cancel = cancel.bind(this);
  this.doSubmit = doSubmit.bind(this);
  this.handleStatus = handleStatus.bind(this);

  this.updateRazonSocial = updateRazonSocial.bind(this);
  this.onChangeRazonSocial = onChangeRazonSocial.bind(this);
  this.mapStateToThis = mapStateToThis.bind(this);

  this.buscar = buscar.bind(this);

  let unsubscribe;


  const sexoQuery = Filter.path('tipo.codigo').eq('sexo');
  const tipoPersonaQuery = Filter.path('tipo.codigo').eq('tipo_persona');
  const tipoDocumentoQuery = Filter.path('tipo.codigo').eq('tipo_documento');


  const valoresFilter = sexoQuery.or(tipoDocumentoQuery).or(tipoPersonaQuery);


  this.$onDestroy = () => {
    this.form();
    $ngRedux.dispatch(rest.actions.valores.reset());
    unsubscribe();
  };

  this.$onInit = () => {
    unsubscribe = $ngRedux.connect(this.mapStateToThis, FormActions)(this);
    if ($stateParams.uid) {
      this.title = this.view ? this.translations['Ver cliente'] : this.translations['Editar cliente'];
      this.formEdit('clientes', $stateParams.uid);
    } else {
      this.title = this.translations['Nuevo cliente'];
      this.form();
    }

    $ngRedux.dispatch(rest.actions.valores.get({ filter: JSON.stringify(valoresFilter) }));

  };

  function mapStateToThis(state) {
    this.handleStatus(state);
    this.model = state.form.model;

    let tiposDocumento = state.valores.data.filter((v) => v.tipo.codigo === 'tipo_documento');
    if (tiposDocumento && !this.model.numeroDocumento) {
      this.model.tipoDocumento = tiposDocumento.filter((tipo) => tipo.value === 'RUC')[0];
    }

    //this.submitted = state.form.flags ? state.form.flags.submitted : false;
    return {
      form: state.form,
      sexos: state.valores.data.filter((v) => v.tipo.codigo === 'sexo'),
      tiposPersona: state.valores.data.filter((v) => v.tipo.codigo === 'tipo_persona'),
      tiposDocumento: state.valores.data.filter((v) => v.tipo.codigo === 'tipo_documento')
    };
  }

  /**
   * Función que se encarga de mostrar mensajes de error en base al estado actual
   *
   * @param {object} state
   */
  function handleStatus(state) {
    if (state.form.notFound) {
      const msg = `${this.translations['No existe el elemento con ID']} ${$stateParams.uid}`;
      ngNotify.set(msg, 'warn');
      $timeout(() => $state.go('home.clientes.list'));
      return;
    }

    if (state.form.error) {
      if (state.form.error.message == 'Cliente Repetido') {
        this.clienteRepetidoNotify();
      } else {
        ngNotify.set(formatErrorMessage(state.form.error.message), { type: 'error', html: true });
      }
    }

    if (state.form.created) {
      ngNotify.set(this.translations['Datos guardados correctamente'], 'success');
      $state.go('home.clientes.list');
    }

    if (state.sucursales.error) {
      ngNotify.set(state.sucursales.error.message, 'error');
    }

    if (state.roles.error) {
      ngNotify.set(state.roles.error.message, 'error');
    }
  }

  this.clienteRepetidoNotify = clienteRepetidoNotify.bind(this);
  function clienteRepetidoNotify() {
    let html = $compile(`<div>${this.translations['Ya existe un cliente con el mismo nombre y apellido, Desea guardar de todos modos?']}<br/><a class="go-in-notify btn btn-danger" ng-click="vm.doSubmit(${true})">${this.translations['Guardar']}</a></div>`)($scope);

    ngNotify.set('<div class="notificacion-cliente-repetido"></div>', {
      position: 'bottom',
      duration: 9000,
      type: 'warn',
      sticky: true,
      button: true,
      html: true
    });

    $timeout(function() {
      $('.notificacion-cliente-repetido').empty();
      $('.notificacion-cliente-repetido').append(html);
    }, 400);
  }

  /**
   * Cancela el formulario y retorna al listado
   */
  function cancel() {
    $state.go('home.clientes.list');
  }

  function updateRazonSocial() {
    this.model.razonSocial = `${this.model.nombre ? this.model.nombre : '' } ${this.model.apellido ? this.model.apellido : ''}`;
  }

  this.updateRUC = updateRUC.bind(this);
  function updateRUC() {
    this.model.nombre = this.model.ruc.nombre;
    this.model.apellido = this.model.ruc.apellido;
    this.model.numeroDocumento = `${this.model.ruc.numero}-${this.model.ruc.digitoVerificador}`;
    this.model.razonSocial = this.model.ruc.razonSocial;
  }

  function onChangeRazonSocial() {
    this.model.nombre = '';
    this.model.apellido = '';
  }

  function doSubmit(guardarDeTodosModos) {
    if ($scope.clienteForm.$invalid) {
      this.submitted = true;
      return;
    }

    var data = Object.assign({}, this.model);
    data.guardarDeTodosModos = guardarDeTodosModos;

    if (this.model.foto && this.model.foto.length) {
      data.foto = this.model.foto[0];
    }

    this.save('clientes', data);
  }
  this.loadClientes = loadClientes.bind(this);

  function loadClientes(query) {
    let filter = Filter.path('activo').eq(true);

    if (query) {
      filter = filter.and(Filter.path('nombre').like(query)
        .or(Filter.path('apellido').like(query))
        .or(Filter.path('razonSocial').like(query))
        .or(Filter.path('numeroDocumento').like(query)));
    } else {
      return;
    }

    BasicFactory.setup('clientes');

    return filter ? BasicFactory.all({ filter: JSON.stringify(filter) }) : BasicFactory.all();
  }

  this.loadRUC = loadRUC.bind(this);
  function loadRUC(query) {
    let filter;

    if (query) {
      filter = Filter.path('nombre').like(query)
        .or(Filter.path('apellido').like(query))
        .or(Filter.path('razonSocial').like(query))
        .or(Filter.path('numero').like(query));
    } else {
      return;
    }

    BasicFactory.setup('ruc');

    return filter ? BasicFactory.all({ filter: JSON.stringify(filter) }) : BasicFactory.all();
  }

  function buscar (parametro) {
    if (parametro) {
      return $ngRedux.dispatch(rest.actions.search({ parametro: parametro }));
    } else {
      return;
    }
  }

  this.renderCliente = renderCliente.bind(this);
  function renderCliente(cliente) {
    let numeroDoc = cliente.numeroDocumento ? cliente.numeroDocumento : 'Sin Nro. Documento';
    return `${cliente.razonSocial} <small><strong>(${numeroDoc})</strong></small>`;
  }

  this.renderRUC = renderRUC.bind(this);
  function renderRUC(ruc) {
    let numeroDoc = ruc.numero && ruc.digitoVerificador ? ruc.numero + "-" + ruc.digitoVerificador : 'Sin Nro. Documento';
    return `${ruc.razonSocial} <small><strong>(${numeroDoc})</strong></small>`;
  }


  this.filterAsociacionFactura = filterAsociacionFactura.bind(this);
  function filterAsociacionFactura(asociacionFactura) {
    return asociacionFactura.id != $stateParams.uid;
  }
}



// WEBPACK FOOTER //
// ./src/components/clientes/form/form.component.js